// extracted by mini-css-extract-plugin
module.exports = {"reference":"a4","eventName":"a5","paramsIndicator":"a6"};